import React from "react";

import { DetectorQueryInput } from "./DetectorQueryInput";

export interface CreateBinaryProps {
  queryValue: string;
  handleChangeValue: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setHasErrors?: (hasErrors: boolean) => void;
}

export function CreateBinary(props: CreateBinaryProps) {
  const { queryValue, handleChangeValue, setHasErrors } = props;
  return (
    <DetectorQueryInput
      queryValue={queryValue}
      handleChangeValue={handleChangeValue}
      setHasErrors={setHasErrors}
      placeholder="Are there any apples in the image?"
    />
  );
}
